import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmployeesServiceProvider } from '../../api/employees'

const EmployeesService = EmployeesServiceProvider()
const name = 'removeEmployeesFromTag'

export default (employeeIds, tagId) => (asyncAction(
  name,
  EmployeesService.removeEmployeesFromTag,
  { employeeIds, tagId }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/employee/removeEmployeesFromTag.js